import React, { useContext, useEffect } from "react"
import DynamicElementList from "components/DynamicElements/DynamicElementList"
import { Box, Button, Typography } from "@mui/material"
import DynamicElementForm from "components/DynamicElements/DynamicElementForm"
import HowToAddDynamicElementsModal from "components/DynamicElements/HowToAddDynamicElementsModal"
import { greyButtonStyle } from "common/buttons"
import i18n from "i18n"
import { useParams } from "react-router-dom"
import {
  FROM_PROJECT,
  useDynamicElements,
} from "hooks/DynamicElements/useDynamicElements"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { DYNAMIC_ELEMENTS } from "constants/entitlements"

const DynamicElementsProject = () => {
  const {
    dynamicElements,
    dispatches,
    isHowToAddModalOpen,
    dynamicElementsConfig,
  } = useDynamicElements()

  const { projectId } = useParams()

  const organizationId = projectId
  useEffect(() => {
    dispatches.setIsFromProject(true)
    if (dynamicElementsConfig.showProjectInitialModal) {
      dispatches.setIsHowToAddModalOpen(true)
    }
    return () => {
      // Esta función se ejecuta al desmontar el componente
      dispatches.setDynamicElementsToInitialState()
    }
  }, [])

  const handleOnUpdate = () => {
    dispatches.getDynamicElementsConvertFrom(organizationId, FROM_PROJECT)
  }

  return (
    <EntitlementPageGuard permission={DYNAMIC_ELEMENTS}>
      <Box sx={{ px: 2 }}>
        {organizationId && (
          <>
            <Typography variant="h6" component="h1" sx={{ mb: 3 }}>
              Elementos dinámicos
            </Typography>
            <DynamicElementList
              className={"mb-3"}
              organizationId={organizationId}
            >
              {dynamicElements && (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      padding: 4,
                      borderRadius: 2,
                      boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "white",
                    }}
                  >
                    <DynamicElementForm poolId={organizationId} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      marginBottom: 1,
                      marginTop: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={greyButtonStyle}
                      onClick={handleOnUpdate}
                    >
                      {i18n.t("buttons.update")}
                    </Button>
                  </Box>
                </>
              )}
            </DynamicElementList>

            {dynamicElementsConfig.showProjectInitialModal && (
              <HowToAddDynamicElementsModal
                open={isHowToAddModalOpen}
                onClose={isOpen => {
                  dispatches.setIsHowToAddModalOpen(isOpen)
                  dispatches.setDynamicElementsConfig({
                    ...dynamicElementsConfig,
                    showProjectInitialModal: false,
                  })
                }}
                onUpdate={handleOnUpdate}
              />
            )}
          </>
        )}
      </Box>
    </EntitlementPageGuard>
  )
}

export default DynamicElementsProject
